import { InitResponse } from '../../redux/types';
import { InitAdapter, SubmitAdapter } from '../../types';

// Order of precedence for initial value is:
// - default value coming from `tags` query param (on new forms only)
// - tags belonging to the parent tier (on new forms only)
// - tags defined in deviation (edit)
// When recommendations come into play, the above three are concatenated
export const initAdapter =
  (parentTierTags?: InitResponse['tags']): InitAdapter =>
  ({ tags }, params, defaultValues) =>
    (defaultValues?.tags || [])
      .map(name => ({ name }))
      .concat(parentTierTags || [])
      .concat(tags || [])
      .map(({ name: tagName }) => tagName);

export const submitAdapter: SubmitAdapter = ({ tags }) => ({
  tags: tags.filter(t => t),
});
